import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { Button, Col, Flex, Form, Input, Row } from "antd";

export default function RenderInput(props) {
	const {
		namePath = [],
		form_question_options = [],
		required = false,
		inputType = "text",
		question = null,
		description = null,
		add_another = false,
	} = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;
	const [inputs, setInputs] = useState(add_another ? [{ id: 0 }] : []);

	const handleAddAnother = () => {
		setInputs((prev) => [...prev, { id: prev.length }]);
	};

	const hasValue = (value) => {
		if (value === 0) {
			return true;
		}

		if (typeof value === "string") {
			return value.trim() !== "";
		}

		return value !== undefined && value !== null && value !== "";
	};

	if (add_another) {
		return (
			<>
				{inputs.map((input, idx) => (
					<Row key={`input_set_${input.id}`}>
						<Col xs={24} sm={24} md={24} lg={24} xl={24}>
							<div
								className="quill-output question"
								dangerouslySetInnerHTML={{
									__html: question,
								}}
							/>
							{description && <div className="description">{description}</div>}
						</Col>

						<Col xs={24} sm={24} md={24} lg={24} xl={24}>
							<Form.Item
								name={`${newNamePath}_set_${idx}`}
								rules={[
									{
										required: required ? true : false,
										message: "This field is required!",
									},
								]}
							>
								<Input placeholder="Answer" size="large" type={inputType} />
							</Form.Item>
						</Col>

						<Form.Item shouldUpdate noStyle>
							{({ getFieldValue }) => {
								const setFieldName = `${newNamePath}_set_${idx}`;
								const setFieldValue = getFieldValue(setFieldName);

								if (!hasValue(setFieldValue)) {
									return null;
								}

								return (
									<RenderInputMemo
										newNamePath={newNamePath}
										idx={idx}
										required={required}
										inputType={inputType}
										form_question_options={form_question_options}
									/>
								);
							}}
						</Form.Item>
					</Row>
				))}

				<Row>
					<Col xs={24} sm={24} md={24} lg={24} xl={24}>
						<Button
							type="link"
							className="w-auto h-auto p-0"
							icon={<FontAwesomeIcon icon={faPlus} />}
							onClick={handleAddAnother}
						>
							Add Another
						</Button>
					</Col>
				</Row>
			</>
		);
	}

	return (
		<Row>
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<div
					className="quill-output question"
					dangerouslySetInnerHTML={{
						__html: question,
					}}
				/>
				{description && <div className="description">{description}</div>}
			</Col>

			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<Form.Item
					name={newNamePath}
					rules={[
						{
							required: required ? true : false,
							message: "This field is required!",
						},
					]}
				>
					<Input placeholder="Answer" size="large" type={inputType} />
				</Form.Item>
			</Col>
		</Row>
	);
}

const RenderInputMemo = (props) => {
	const { newNamePath, idx, required, inputType, form_question_options } =
		props;

	return (
		<>
			<Col xs={24} sm={24} md={24} lg={24} xl={24} className="ml-20">
				<Row gutter={[20, 0]}>
					{form_question_options.filter((x) => !x.is_other).length
						? form_question_options
								.filter((x) => !x.is_other)
								.map((item, index) => {
									return (
										<Col
											key={`input_option_${index}`}
											xs={24}
											sm={24}
											md={24}
											lg={24}
											xl={24}
										>
											<Flex align="center">{item.option}</Flex>

											<Row gutter={[20, 0]} className="ml-20">
												{item.form_question_options.filter((x) => !x.is_other)
													.length
													? item.form_question_options
															.filter((x) => !x.is_other)
															.map((subItem, subIndex) => {
																return (
																	<Col
																		key={`input_set_${idx}_option_${index}_sub_option_${subIndex}`}
																		xs={24}
																		sm={24}
																		md={24}
																		lg={24}
																		xl={24}
																	>
																		<Flex align="center">{subItem.option}</Flex>
																		<Form.Item
																			key={`input_set_${idx}_option_${index}_sub_option_${subIndex}`}
																			name={`${newNamePath}_set_${idx}_option_${index}_sub_option_${subIndex}`}
																			rules={[
																				{
																					required: required ? true : false,
																					message: "This field is required!",
																				},
																			]}
																		>
																			<Input
																				placeholder="Answer"
																				size="large"
																				type={inputType}
																			/>
																		</Form.Item>
																	</Col>
																);
															})
													: []}
											</Row>
										</Col>
									);
								})
						: []}
				</Row>
			</Col>
		</>
	);
};
